export default __webpack_public_path__ + "static/Force-bf5ca3d025e7ea500205e917e4d9a5bb.png";